import parametrizacaoRepository from './parametrizacaoRepository'
import gerenciamentoEnvioRepository from './gerenciamentoEnvioRepository'

export default baseUrl => {
    return {
        parametrizacao: parametrizacaoRepository(baseUrl),
        gerenciamentoEnvio: gerenciamentoEnvioRepository(baseUrl),
    }
}
